import React from "react";

const BenefitItem = ({ boldText, regularText }) => {
  return (
    <div className="flex items-start gap-3">
      <div className="w-6 h-6 bg-[#FFF5CE]/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
        <svg
          className="w-4 h-4 fill-[#FFF5CE]"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
      </div>
      <span className="text-sm leading-relaxed">
        <strong>{boldText}</strong> {regularText}
      </span>
    </div>
  );
};

const PlatformBenefits = () => {
  const benefits = [
    {
      id: 1,
      boldText: "Save 2-3 hours weekly",
      regularText: "on administrative tasks with automated workflows",
    },
    {
      id: 2,
      boldText: "Manage multiple properties",
      regularText: "from a single, organised dashboard",
    },
    {
      id: 3,
      boldText: "Channel manager integration",
      regularText: "— Lodgify integration available now, many more coming soon",
    },
    {
      id: 4,
      boldText: "Professional documentation",
      regularText: "with photo and video verification of every completed task",
    },
    {
      id: 5,
      boldText: "UK-based platform",
      regularText: "with GDPR compliance and secure data handling",
    },
  ];

  return (
    <div className="bg-gradient-to-br from-[#586989] to-[#106A3A] p-8 rounded-2xl text-[#FFF5CE]">
      <h3 className="text-2xl font-bold mb-6">
        Why Property Owners Choose HouseKeeper
      </h3>
      <div className="flex flex-col gap-4">
        {benefits.map((benefit) => (
          <BenefitItem
            key={benefit.id}
            boldText={benefit.boldText}
            regularText={benefit.regularText}
          />
        ))}
      </div>
    </div>
  );
};

export default PlatformBenefits;
